var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('authorization-layout',[[_c('div',{staticClass:"container px-2"},[_c('login-modal',{attrs:{"is-modal":false}})],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }